import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const lockerBooking = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  saveBookingOfAnUser (locationId, lockerId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/lockers/${lockerId}/bookings`, body)
  },
  deleteBookingOfAnUser (lockerId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/lockers/${lockerId}/bookings/${bookingId}`)
  },
  markBookingAsCheckedOutOfAnUser (locationId, lockerId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/lockers/${lockerId}/bookings/${bookingId}/checkout`)
  },
  getAllLockersWithTheirBookings(term, locationId, date) {
    const query = utils.generateQueryString({term, locationId, date}, false)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/lockers/active`, query)
  },
  markBookingAsCheckedIn (locationId, lockerId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/lockers/${lockerId}/bookings/${bookingId}/checkin`)
  },
  markBookingAsCheckedOut (locationId, lockerId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/lockers/${lockerId}/bookings/${bookingId}/checkout`)
  },
  deleteLockerBooking (lockerId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/lockers/${lockerId}/bookings/${bookingId}`)
  },
  createNewBooking (locationId, lockerId, body) {
    return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/lockers/${lockerId}/bookings`, body)
  }
}

export default lockerBooking
